<template>
  <ModalComponent
    ref="minimumPriceModal"
    :submitButtonText="$t('common.close')"
  >
    <template #title>
      <h4 class="d-flex align-items-center">
        <font-awesome-icon
          :icon="'fas fa-info-circle'"
          class="text-secondary-emphasis me-2"
        />
        {{ $t("setPriceTerms.howMinimumPriceWorks") }}
      </h4>
    </template>
    <template #body>
      <div class="p-3">
        <p class="mb-3 lh-lg">
          {{ $t("setPriceTerms.contentParagraph1") }}
        </p>
        <p class="mb-3 lh-lg">
          {{ $t("setPriceTerms.content_paragraph_2") }}
        </p>
        <p class="mb-3 lh-lg">
          {{
            $t("setPriceTerms.content_paragraph_3", {
              duration: durationMonths,
            })
          }}
        </p>
      </div>
    </template>
  </ModalComponent>
</template>

<script setup lang="ts">
import ModalComponent from "@/components/common/ModalComponent.vue";
import { useCompanySpotStrategy } from "@/composables/useCompanySpotStrategy";
import { computed, useTemplateRef } from "vue";

const minimumPriceModal =
  useTemplateRef<InstanceType<typeof ModalComponent>>("minimumPriceModal");

const currentStrategy = useCompanySpotStrategy();
const durationMonths = computed(
  () => currentStrategy.value.durationMonths ?? 6
);

const toggleModal = () => {
  if (minimumPriceModal.value) {
    minimumPriceModal.value.toggleModal();
  }
};

defineExpose({
  toggleModal,
});
</script>
